import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faClock,
  faPlus,
  faUserAlt,
  faEye,
  faEyeSlash,
  faCalendarAlt,
  faCaretRight,
  faAngleRight,
  faExclamationCircle,
  faExclamationTriangle,
  faCaretLeft,
  faCaretUp,
  faCircle,
  faQuestionCircle,
  faTrashAlt,
  faSearch
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faClock,
  faPlus,
  faEye,
  faUserAlt,
  faEyeSlash,
  faCalendarAlt,
  faCaretRight,
  faExclamationCircle,
  faAngleRight,
  faCaretLeft,
  faCaretUp,
  faCircle,
  faExclamationTriangle,
  faQuestionCircle,
  faTrashAlt,
  faSearch
);
